import { z } from "zod";

export const signInSchema = z.object({
  email: z
    .string()
    .email('Невірний формат електронної пошти') // Ensures the string is a valid email format
    .min(1, 'Електронна пошта обов\'язкова'),   // Ensures email is not empty

  password: z
    .string()
    .min(1, 'Обовязкове поле') // Ensures password is at least 6 characters long
});

export type SignInInfoFormScheme = z.infer<typeof signInSchema>;
